<script lang="ts">
  /**
   * Знак MartaFit Space — сонце, що сходить над лінією горизонту.
   * Сонце завжди фірмове (Сонце #E8A13D), лінія бере колір із контексту
   * через currentColor, тому знак читається і на Кремі, і на Ночі.
   */
  interface Props {
    size?: number;
    /** Explicit color override for the horizon line. If omitted, the SVG
     *  inherits via currentColor from the parent CSS. */
    color?: string;
  }
  let { size = 88, color }: Props = $props();
  const height = $derived(Math.round((size / 460) * 260));
</script>

<svg
  width={size}
  {height}
  viewBox="0 0 460 260"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  style:color
>
  <path d="M 125 158 A 105 105 0 0 1 335 158 Z" fill="#E8A13D" />
  <rect x="30" y="155.5" width="400" height="5" rx="2.5" fill="currentColor" />
</svg>
